export const environment = {
  production: true,
  name: 'production',
  loglevel: 5,
  version: '3.43.00'
};
